import React from "react";
import "./ourPartners.css";
import logos from "../../Common/logo.json";
import useViewport from "../../Common/GetViewPort";

const OurPartners = (props) => {
  const t = props.language;
  const logoInvestor1 = logos["investors-1"];
  const logoArchitect1 = logos["architect-1"];
  const financial1 = logos["financial-instu-1"];
  const financial2 = logos["financial-instu-2"];
  const sourcing1 = logos["sourcing-1"];
  const sourcing2 = logos["sourcing-2"];
  const notary = logos["notary"];
  const lawyers = logos["lawyers"];
  const technical1 = logos["technical-1"];
  const technical2 = logos["technical-2"];
  const width = useViewport().width;

  return (
    <div className="partner" id={"partners"}>
      <div className="partner__container">
        <div className="partner__div">
          <div className="text__partner">
            {t("our_partners")}
            <span className="line__partner"></span>
          </div>
          <div className="team__desc--wrap">
            <p className="team__desc">{t("partner_page")}</p>
          </div>
        </div>

        <div className="logo__div">
          <div className="moving__div">
            <h1 className="logo__genre">{t("investors")}</h1>
            <div className="width__div animation--right">
              <div className="logo__line logo__1">
                {logoInvestor1.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
              <div className="logo__line logo__1">
                {logoInvestor1.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
            </div>
          </div>
          <div className="moving__div">
            <h1 className="logo__genre">{t("architects")}</h1>
            <div className="width__div animation--right">
              <div className="logo__line logo__1">
                {logoArchitect1.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
              <div className="logo__line logo__1">
                {logoArchitect1.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
            </div>
          </div>
          <div className="moving__div">
            <h1 className="logo__genre">{t("fi")}</h1>
            <div className="width__div animation--right">
              <div className="logo__line logo__1">
                {financial1.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
              <div className="logo__line logo__1">
                {financial1.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="logo__div">
          <div className="moving__div">
            <h1 className="logo__genre">Sourcing</h1>
            <div className="width__div animation--right">
              <div className="logo__line logo__1">
                {sourcing1.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
              <div className="logo__line logo__1">
                {sourcing1.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
            </div>
          </div>
          <div className="moving__div">
            <h1 className="logo__genre">{t("technical")}</h1>
            <div className="width__div animation--right">
              <div className="logo__line logo__1">
                {technical1.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
              <div className="logo__line logo__1">
                {technical1.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="logo__div">
          <div className="moving__div">
            <h1 className="logo__genre">{t("ln")}</h1>
            <div className="width__div animation--right">
              <div className="logo__line logo__1">
                {lawyers.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
              <div className="logo__line logo__1">
                {lawyers.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logo/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
            </div>
          </div>
          {/* <div className="moving__div">
            <h1 className="logo__genre">Notary</h1>
            <div className="width__div animation--right">
              <div className="logo__line logo__1">
                {notary.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logos/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
              <div className="logo__line logo__1">
                {notary.map((logo, index) => {
                  return (
                    <img
                      src={require(`../../Assets/Logos/${logo.image}`)}
                      alt="logo_partner"
                      className="logo__partner"
                      key={index}
                    />
                  );
                })}
              </div>
            </div>
          </div> */}
        </div>
        {/* <div className="grid__logo">
          <div className="logo1">
            <div className="logo__width">
              <h1 className="logo__genre">Sourcing</h1>
              <div
                className={
                  width >= 1280
                    ? `grid-width__div grid-animation--right`
                    : `width__div animation--right`
                }
              >
                <div className="logo__line logo__1">
                  {sourcing1.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
                <div className="logo__line logo__1">
                  {sourcing1.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
              </div>
              <div
                className={
                  width >= 1280
                    ? `grid-width__div grid-animation--left`
                    : `width__div animation--left`
                }
              >
                <div className="logo__line logo__1">
                  {sourcing2.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
                <div className="logo__line logo__1">
                  {sourcing2.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="logo2">
            <div className="logo__width">
              <h1 className="logo__genre">Technical</h1>
              <div
                className={
                  width >= 1280
                    ? `grid-width__div grid-animation--right`
                    : `width__div animation--right`
                }
              >
                <div className="logo__line logo__1">
                  {technical1.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
                <div className="logo__line logo__1">
                  {technical1.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
              </div>
              <div
                className={
                  width >= 1280
                    ? `grid-width__div grid-animation--left`
                    : `width__div animation--left`
                }
              >
                <div className="logo__line logo__1">
                  {technical2.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
                <div className="logo__line logo__1">
                  {technical2.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="logo3">
            <div className="logo__width">
              <h1 className="logo__genre">Lawyers</h1>
              <div
                className={
                  width >= 1280
                    ? `grid-width__div grid-animation--right`
                    : `width__div animation--right`
                }
              >
                <div className="logo__line logo__1">
                  {lawyers.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
                <div className="logo__line logo__1">
                  {lawyers.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="logo4">
            <div className="logo__width">
              <h1 className="logo__genre">Notary</h1>
              <div
                className={
                  width >= 1280
                    ? `grid-width__div grid-animation--right`
                    : `width__div animation--right`
                }
              >
                <div className="logo__line logo__1">
                  {notary.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
                <div className="logo__line logo__1">
                  {notary.map((logo, index) => {
                    return (
                      <img
                        src={require(`../../Assets/Logos/${logo.image}`)}
                        alt="logo_partner"
                        className="logo__partner"
                        key={index}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default OurPartners;
